<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      @reload="reload"
    >
    </page-main>
  </div>
</template>
<script>
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageMain },
  mixins: [BaseTable],
  props: { orderBatchCode: { type: String, default: '' } },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .orderBatchGoodsListApi({ orderBatchCode: this.orderBatchCode })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
